/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon24Regular = forwardRef('BookClosedIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 6a.75.75 0 0 0 0 1.5h8A.75.75 0 0 0 16 6H8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 1.25A3.75 3.75 0 0 0 3.25 5v15A2.75 2.75 0 0 0 6 22.75h14a.75.75 0 0 0 0-1.5H6a1.25 1.25 0 1 1 0-2.5h12.5a2.25 2.25 0 0 0 2.25-2.25v-13a2.25 2.25 0 0 0-2.25-2.25H7Zm-1 16c-.45 0-.875.108-1.25.3V5A2.25 2.25 0 0 1 7 2.75h11.5a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-.75.75H6Z" })));
});
